export default "__VITE_ASSET__00c55a84__"